import { BaseRequest } from "./BaseRequest";

class BaseRequestMID extends BaseRequest {
  private MerchantID: number;

  /**
   *
   */
  constructor(SessionID: string | null, MerchantID: number) {
    super(SessionID);
    this.MerchantID = MerchantID;
  }
}
export { BaseRequestMID };
